var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"red-text text-darken-3"},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('div',[_c('card-input',{attrs:{"submit":_vm.submit,"reset-token":_vm.resetToken}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }